import { render, staticRenderFns } from "./Hemodinamia.vue?vue&type=template&id=47f0bfab&scoped=true&"
import script from "./Hemodinamia.vue?vue&type=script&lang=js&"
export * from "./Hemodinamia.vue?vue&type=script&lang=js&"
import style0 from "./Hemodinamia.vue?vue&type=style&index=0&id=47f0bfab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0bfab",
  null
  
)

export default component.exports